/**
 * Auto Free Gift - 
 */

(function() {
  'use strict';

  const GIFT_VARIANT_ID = 51805112860999;
  const GIFT_PRODUCT_ID = 10220318753095;
  const TRIGGER_COLLECTION = 'classic';

  console.log('🎁 Gift script geladen');

  let collectionProductIds = null;

  // Haal alle product IDs uit de trigger collectie
  async function getCollectionProducts() {
    if (collectionProductIds) return collectionProductIds;
    
    try {
      // Haal eerste 250 producten
      const res = await fetch(`/collections/${TRIGGER_COLLECTION}/products.json?limit=250`);
      if (res.ok) {
        const data = await res.json();
        collectionProductIds = data.products.map(p => p.id);
        console.log(`Collectie "${TRIGGER_COLLECTION}": ${collectionProductIds.length} producten`);
        return collectionProductIds;
      }
    } catch (e) {
      console.log('Collectie laden mislukt:', e);
    }
    
    collectionProductIds = [];
    return collectionProductIds;
  }

  async function checkCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      
      if (!cart.items || cart.items.length === 0) return;

      // Haal collectie producten op
      const triggerProducts = await getCollectionProducts();

      // Check of cadeau al in cart zit
      let giftInCart = false;
      let giftKey = null;
      
      for (const item of cart.items) {
        if (item.product_id == GIFT_PRODUCT_ID || item.variant_id == GIFT_VARIANT_ID) {
          giftInCart = true;
          giftKey = item.key;
          break;
        }
      }

      // Check of er een product uit de trigger collectie in cart zit
      let hasTrigger = false;
      
      for (const item of cart.items) {
        // Skip cadeau zelf
        if (item.product_id == GIFT_PRODUCT_ID) continue;
        
        // Check of product in trigger collectie zit
        if (triggerProducts.includes(item.product_id)) {
          hasTrigger = true;
          console.log('Trigger gevonden:', item.title);
          break;
        }
      }

      console.log('Cart check:', { hasTrigger, giftInCart });

      // Voeg cadeau toe
      if (hasTrigger && !giftInCart) {
        console.log('🎁 Cadeau toevoegen...');
        
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
          })
        });
        
        if (res.ok) {
          console.log('✅ Cadeau toegevoegd!');
          location.reload();
        }
      }
      
      // Verwijder cadeau als geen trigger
      if (!hasTrigger && giftInCart && giftKey) {
        console.log('🗑️ Cadeau verwijderen...');
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftKey, quantity: 0 })
        });
        location.reload();
      }

    } catch (e) {
      console.error('Gift error:', e);
    }
  }

  // Start
  setTimeout(checkCart, 1000);

  // Luister naar cart changes
  const _fetch = window.fetch;
  window.fetch = function(...args) {
    return _fetch.apply(this, args).then(res => {
      if (args[0]?.includes?.('/cart/')) setTimeout(checkCart, 1500);
      return res;
    });
  };

})();
